import { useMemo } from 'react';
import { useUnmount } from './';
function usePortalContainer(identifier, enabled) {
    if (enabled === void 0) { enabled = true; }
    var container = useMemo(function () {
        var container = null;
        if (!enabled)
            return container;
        var index = 1;
        while (!container) {
            var id = "RUI".concat(identifier, "-").concat(index);
            if (document.getElementById(id)) {
                index += 1;
            }
            else {
                container = document.createElement('div');
                container.className = "RUI".concat(identifier, "-Portal");
                container.id = id;
                document.body.appendChild(container);
            }
        }
        return container;
    }, []);
    useUnmount(function () {
        if (container)
            container.remove();
    });
    return container;
}
export default usePortalContainer;
